/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { getMaterialImage, getSerialProductIcon } from '@/utils/image'
import product from './product'
import { PRODUCT_ATTRIBUTE } from './const'
import { FormattedProduct } from '@/store'
import { ClickAction } from './report'

const H5699_H5696 = {
  title: [
    ['J12 CALIBER 12.2', '腕表'],
    ['33', '毫米']
  ],
  variants: ['H5699', 'H5696'],
  materials: [PRODUCT_ATTRIBUTE.WHITE_CERAMIC, PRODUCT_ATTRIBUTE.BLACK_CERAMIC]
}

const H6951 = {
  title: [['PREMIÈRE ÉDITION'], ['ORIGINALE', '腕表']],
  variants: ['H6951'],
  materials: [PRODUCT_ATTRIBUTE.YELLOW_GOLD]
}

const H5700_H5697 = {
  title: [
    ['J12 CALIBER 12.1', '腕表'],
    ['38', '毫米']
  ],
  variants: ['H5700', 'H5697'],
  materials: [PRODUCT_ATTRIBUTE.WHITE_CERAMIC, PRODUCT_ATTRIBUTE.BLACK_CERAMIC]
}

const H5703_H5701 = {
  title: [
    ['J12', '腕表'],
    ['33', '毫米']
  ],
  variants: ['H5703', 'H5701'],
  materials: [PRODUCT_ATTRIBUTE.WHITE_CERAMIC, PRODUCT_ATTRIBUTE.BLACK_CERAMIC]
}

const H5705_H5702 = {
  title: [
    ['J12 CALIBER 12.1', '腕表'],
    ['38', '毫米']
  ],
  variants: ['H5705', 'H5702'],
  materials: [PRODUCT_ATTRIBUTE.WHITE_CERAMIC, PRODUCT_ATTRIBUTE.BLACK_CERAMIC]
}

export type PRODUCT_SERIE = typeof H5699_H5696
const format = (
  { title, variants, materials }: PRODUCT_SERIE,
  index: 0 | 1,
  actionNumber: ClickAction
) => {
  const skuId = variants[index]
  const base = product.WATCH.find(p => p.skuId === skuId)! as FormattedProduct
  const icon = getSerialProductIcon(base)
  const materialIcons = materials.map(material =>
    getMaterialImage(material.icon)
  )

  return {
    skuId,
    title,
    icon,
    variants,
    materialIcons,
    actionNumber
  }
}

export type FORMATTED_PRODUCT_SERIE = ReturnType<typeof format>

export const PRODUCT_SERIES_MAP = {
  H5699_H5696,
  H6951,
  H5700_H5697,
  H5703_H5701,
  H5705_H5702
}

export const PRODUCT_SERIES_LIST = [
  format(H5699_H5696, 0, ClickAction.WATCH_H5699),
  format(H6951, 0, ClickAction.WATCH_H6951),
  format(H5700_H5697, 1, ClickAction.WATCH_H5697),
  format(H5703_H5701, 0, ClickAction.WATCH_H5703),
  format(H5699_H5696, 1, ClickAction.WATCH_H5696),
  format(H5700_H5697, 0, ClickAction.WATCH_H5700),
  format(H5703_H5701, 1, ClickAction.WATCH_H5701),
  format(H5705_H5702, 0, ClickAction.WATCH_H5705),
  format(H5705_H5702, 1, ClickAction.WATCH_H5702)
]
